document.addEventListener('DOMContentLoaded', function () {
  const wrap = document.getElementById('mobilePacksCarousel');
  if (!wrap) return;

  const inner = wrap.querySelector('.carousel-inner');
  const items = [...wrap.querySelectorAll('.carousel-item')];
  const dots  = wrap.querySelector('.carousel-indicators');
  const prev  = wrap.querySelector('.carousel-control-prev');
  const next  = wrap.querySelector('.carousel-control-next');

  // === If Bootstrap is available, use it ===
  if (window.bootstrap && bootstrap.Carousel) {
    // build indicators once
    if (dots && !dots.children.length) {
      items.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-bs-target', '#mobilePacksCarousel');
        b.setAttribute('data-bs-slide-to', String(i));
        b.setAttribute('aria-label', `Slide ${i + 1}`);
        if (i === 0) { b.classList.add('active'); b.setAttribute('aria-current','true'); }
        dots.appendChild(b);
      });
    }
    // init (no auto-ride)
    bootstrap.Carousel.getInstance(wrap) ||
      new bootstrap.Carousel(wrap, { interval:false, ride:false, wrap:true, touch:true });
    return;
  }

  // === Fallback (no Bootstrap) - reviews-style slider ===
  wrap.classList.add('no-bs');                 // let your CSS target fallback
  if (!wrap.querySelector('.carousel-item.active') && items.length) {
    items[0].classList.add('active');          // a11y: one active
  }

  // Build dots
  if (dots && !dots.children.length) {
    items.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Slide ${i + 1}`);
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', () => {
        inner.scrollTo({ left: i * inner.clientWidth, behavior: 'smooth' });
        [...dots.children].forEach(d => d.removeAttribute('aria-current'));
        b.setAttribute('aria-current','true');
      });
      dots.appendChild(b);
    });
  }

  const getIndex = () => Math.round(inner.scrollLeft / inner.clientWidth);
  const goTo = (i) => {
    const max = items.length - 1;
    const clamped = Math.max(0, Math.min(max, i));
    inner.scrollTo({ left: clamped * inner.clientWidth, behavior: 'smooth' });
    if (dots && dots.children[clamped]) {
      [...dots.children].forEach(d => d.removeAttribute('aria-current'));
      dots.children[clamped].setAttribute('aria-current','true');
    }
  };

  prev && prev.addEventListener('click', e => { e.preventDefault(); goTo(getIndex() - 1); });
  next && next.addEventListener('click', e => { e.preventDefault(); goTo(getIndex() + 1); });

  // keep current slide on resize
  let last = 0;
  window.addEventListener('resize', () => {
    const i = getIndex();
    if (i !== last) last = i;
    inner.scrollTo({ left: last * inner.clientWidth });
  });
});
